export default __webpack_public_path__ + "static/media/desktop_dr_03.2a2d172f.png";